<template>
    <div class="release-payment-receipt">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Consulta/Registro"
                    sub="Registro (Pagamento/Recebimento)"
                />
            </b-col>
        </b-row>
        <b-row v-if="this.operation_id">
            <div class="stats">
                <Stat
                    title="Em Aberto"
                    :value="this.total_plot_open"
                    color="#d54d50"
                />
                <Stat
                    title="Pago"
                    :value="this.total_plot_closed"
                    color="#3bc480"
                />
                <Stat title="Total" :value="this.total_plot" color="#3282cd" />
            </div>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data de Vencimento Início:"
                    label-for="release-payment-receipt-start_date"
                >
                    <b-form-input
                        id="release-payment-receipt-start_date"
                        type="date"
                        v-model="start_date"
                        v-on:keyup.enter="loadReleases"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data de Vencimento Término:"
                    label-for="release-payment-receipt-end_date"
                >
                    <b-form-input
                        id="release-payment-receipt-end_date"
                        type="date"
                        v-model="end_date"
                        v-on:keyup.enter="loadReleases"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="release-payment-receipt-company_id"
                >
                    <b-form-select
                        id="release-payment-receipt-company_id"
                        @input="loadReleases"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Operação:"
                    label-for="release-payment-receipt-operation_id"
                >
                    <b-form-select
                        id="release-payment-receipt-operation_id"
                        @input="loadReleases"
                        size="sm"
                        :options="operations"
                        v-model="operation_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Liquidado:"
                    label-for="release-payment-receipt-closed"
                >
                    <b-form-select
                        id="release-payment-receipt-closed"
                        @input="loadReleases"
                        size="sm"
                        :options="questionboxyesnoalls"
                        v-model="closed"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="1" sm="2">
                <b-form-group label="ID" label-for="entity-id">
                    <b-form-input
                        id="entity-id"
                        type="text"
                        v-model="entity_id"
                        v-on:keyup.enter="openModalEntity"
                        @input=";[setEntity(), loadReleases()]"
                        size="sm"
                        placeholder="Código..."
                    />
                </b-form-group>
            </b-col>
            <b-link v-b-modal.modalEntity class="fa fa-search mt-4"></b-link>
            <b-col md="4" sm="8">
                <b-form-group label="Nome:" label-for="entity-name_entity">
                    <b-form-input
                        id="entity-name_entity"
                        type="text"
                        v-model="entity.name_entity"
                        size="sm"
                        :readonly="true"
                        placeholder="Nome..."
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="2">
                <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                    <b-form-input
                        id="entity-cnpj_cpf"
                        type="text"
                        v-model="entity.cnpj_cpf"
                        size="sm"
                        :readonly="true"
                        placeholder=""
                    />
                </b-form-group>
            </b-col>

            <b-col md="2" sm="2">
                <b-button
                    size="sm"
                    class="mt-4 fa"
                    :class="icon"
                    @click=";[loadReleases(), (showTable = !showTable)]"
                    variant="light"
                >
                </b-button>
                <b-button
                    size="sm"
                    title="Relatório Financeiro"
                    @click="printerPaymentReceipt"
                    variant="light"
                    class="mr-2 mt-4 ml-2 fa fa-print"
                ></b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>

                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            sticky-header
                            head-variant="light"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                            :items="releasesplots"
                            :fields="fieldsRelease"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    size="sm"
                                    @click="data.toggleDetails"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-bars"></i>
                                </b-button>
                                <b-button
                                    title="Nova Parcela"
                                    v-show="!data.item.closed"
                                    v-b-modal.modalNwePlots
                                    size="sm"
                                    variant="light"
                                    @click="loadReleasesPlot(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-plus"></i>
                                </b-button>
                                <b-button
                                    title="Editar registro"
                                    v-show="!data.item.closed"
                                    v-b-modal.modalPlots
                                    size="sm"
                                    variant="light"
                                    @click="loadReleasesPlot(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                                <b-button
                                    title="Liberar"
                                    size="sm"
                                    v-show="
                                        data.item.blocked && !data.item.closed
                                    "
                                    variant="light"
                                    @click="unblocked(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-unlock"></i>
                                </b-button>
                                <b-button
                                    title="Não Liberar"
                                    size="sm"
                                    v-show="
                                        !data.item.blocked && !data.item.closed
                                    "
                                    variant="light"
                                    @click="blocked(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-unlock-alt"></i>
                                </b-button>
                                <b-button
                                    title="Liquidação"
                                    size="sm"
                                    v-show="
                                        !data.item.blocked && !data.item.closed
                                    "
                                    v-b-modal.modalSettlement
                                    variant="light"
                                    @click="
                                        ;[
                                            loadSettlement(data.item),
                                            loadEntitySettlements()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-money"></i>
                                </b-button>
                                <b-button
                                    title="Cancelar Liquidação"
                                    size="sm"
                                    v-show="data.item.closed"
                                    variant="light"
                                    @click="
                                        ;[
                                            loadSettlementReleaseSplot(
                                                data.item
                                            ),
                                            showMsgBoxCanceled()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-ban"></i>
                                </b-button>
                                <b-button
                                    title="Recontabilização"
                                    size="sm"
                                    variant="light"
                                    v-show="data.item.closed"
                                    @click="
                                        ;[
                                            documentSettlementRelease(
                                                data.item
                                            ),
                                            showMsgBoxAccounting()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                            </template>
                            <template v-slot:cell(accesses)="data">
                                <b-button
                                    title="Detalhe da Liquidação"
                                    size="sm"
                                    v-show="data.item.closed"
                                    v-b-modal.modalDocumentSettlement
                                    variant="light"
                                    @click="
                                        ;[documentSettlementRelease(data.item)]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-drivers-license-o"></i>
                                </b-button>
                                <b-button
                                    title="Acesso ao Lançamento"
                                    size="sm"
                                    variant="light"
                                    @click=";[actionEditRelease(data.item)]"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                                <b-button
                                    title="Acesso a Contabilização"
                                    size="sm"
                                    variant="light"
                                    v-b-modal.modalAccounting
                                    v-show="data.item.accounting_release_splot"
                                    @click="accountingRelease(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-puzzle-piece"></i>
                                </b-button>
                            </template>

                            <template slot="row-details" slot-scope="data">
                                <b-card>
                                    <b-row>
                                        <b-col md="5" sm="6">
                                            <b-row class="mb-2">
                                                <b-col
                                                    sm="3"
                                                    class="text-sm-right"
                                                    ><b>Condição:</b></b-col
                                                >
                                                <b-col>{{
                                                    data.item
                                                        .name_condition_payment_receipt
                                                }}</b-col>
                                            </b-row>

                                            <b-row class="mb-2">
                                                <b-col
                                                    sm="3"
                                                    class="text-sm-right"
                                                    ><b>Multa:</b></b-col
                                                >
                                                <b-col>{{
                                                    data.item.fine_value
                                                }}</b-col>
                                            </b-row>
                                            <b-row class="mb-2">
                                                <b-col
                                                    sm="3"
                                                    class="text-sm-right"
                                                    ><b>Juros:</b></b-col
                                                >
                                                <b-col>{{
                                                    data.item
                                                        .interest_rate_value
                                                }}</b-col>
                                            </b-row>
                                            <b-row class="mb-2">
                                                <b-col
                                                    sm="3"
                                                    class="text-sm-right"
                                                    ><b>Desconto:</b></b-col
                                                >
                                                <b-col>{{
                                                    data.item.discount_value
                                                }}</b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="5" sm="6">
                                            <b-row class="mb-2">
                                                <b-col
                                                    sm="3"
                                                    class="text-sm-right"
                                                    ><b
                                                        >Total Documento:</b
                                                    ></b-col
                                                >
                                                <b-col>{{
                                                    data.item.release_value
                                                }}</b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>

                                    <b-button
                                        size="sm"
                                        @click="data.toggleDetails"
                                        >Fechar Detalhe</b-button
                                    >
                                </b-card>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalPlots"
            ref="modal"
            title-tag="h6"
            title="Parcelas"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="savePlot"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data de Vencto:"
                            label-for="releasesplot-due_date"
                        >
                            <b-form-input
                                id="releasesplot-due_date"
                                type="date"
                                v-model="releasesplot.due_date"
                                size="sm"
                                :readonly="true"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data Programada:"
                            label-for="releasesplot-scheduled_date"
                        >
                            <b-form-input
                                id="releasesplot-scheduled_date"
                                type="date"
                                v-model="releasesplot.scheduled_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Parcela:"
                            label-for="releasesplot-portion_value"
                        >
                            <b-form-input
                                id="releasesplot-portion_value"
                                v-model="releasesplot.portion_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Multa:"
                            label-for="releasesplot-fine_value"
                        >
                            <b-form-input
                                id="releasesplot-fine_value"
                                v-model="releasesplot.fine_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Juros:"
                            label-for="releasesplot-interest_rate_value"
                        >
                            <b-form-input
                                id="releasesplot-interest_rate_value"
                                v-model="releasesplot.interest_rate_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Desconto:"
                            label-for="releasesplot-discount_value"
                        >
                            <b-form-input
                                id="releasesplot-discount_value"
                                v-model="releasesplot.discount_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Final:"
                            label-for="releasesplot-final_value"
                        >
                            <b-form-input
                                id="releasesplot-final_value"
                                v-model="releasesplot.final_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalSettlement"
            ref="modal"
            title-tag="h6"
            title="Liquidação"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveSettlement"
        >
            <b-form>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="Data de Liquidação:"
                            label-for="documentsettlement-settlement_date"
                        >
                            <b-form-input
                                id="documentsettlement-settlement_date"
                                type="date"
                                v-model="documentsettlement.settlement_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor de Liquidação:"
                            label-for="documentsettlement-settlement_value"
                        >
                            <b-form-input
                                id="documentsettlement-settlement_value"
                                v-model="documentsettlement.settlement_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10" sm="12">
                        <b-form-group
                            label="Conta Banco/Caixa:"
                            label-for="documentsettlement-entity_settlement_id"
                        >
                            <b-form-select
                                id="documentsettlement-entity_settlement_id"
                                size="sm"
                                :options="entitysettlements"
                                v-model="
                                    documentsettlement.entity_settlement_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="5" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="
                                        documentsettlement.settlement_eletronic
                                    "
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="documentsettlement-settlement_eletronic"
                                />
                                <label
                                    class="form-check-label"
                                    for="documentsettlement-settlement_eletronic"
                                >
                                    Liquidação Eletrônica?
                                </label>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group
                            v-show="documentsettlement.settlement_eletronic"
                            label="Valor Transação Eletrônica:"
                            label-for="documentsettlement-eletronic_value"
                        >
                            <b-form-input
                                id="documentsettlement-eletronic_value"
                                v-model="documentsettlement.eletronic_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                v-show="documentsettlement.settlement_eletronic"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalNwePlots"
            ref="modal"
            title-tag="h6"
            title="Nova Parcela"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveNewPlot"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data de Vencto:"
                            label-for="newreleasesplot-due_date"
                        >
                            <b-form-input
                                id="newreleasesplot-due_date"
                                type="date"
                                v-model="newreleasesplot.due_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data Programada:"
                            label-for="newreleasesplot-scheduled_date"
                        >
                            <b-form-input
                                id="newreleasesplot-scheduled_date"
                                type="date"
                                v-model="newreleasesplot.scheduled_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Parcela:"
                            label-for="newreleasesplot-portion_value"
                        >
                            <b-form-input
                                id="newreleasesplot-portion_value"
                                v-model="newreleasesplot.portion_value"
                                @input="
                                    newreleasesplot.final_value =
                                        newreleasesplot.portion_value
                                "
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Final:"
                            label-for="newreleasesplot-final_value"
                        >
                            <b-form-input
                                id="newreleasesplot-final_value"
                                v-model="newreleasesplot.final_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="Forma de Pagamento/Recebimento:"
                            label-for="newreleasesplot-settlement_form_id"
                        >
                            <b-form-select
                                id="newreleasesplot-settlement_form_id"
                                size="sm"
                                :options="settlementforms"
                                v-model="newreleasesplot.settlement_form_id"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalAccounting"
            centered
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Contabilização"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            hide-footer
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    head-variant="dark"
                    :items="accountingentrys"
                    :fields="fieldsAccounting"
                ></b-table>
            </b-form>
        </b-modal>
        <b-modal
            id="modalDocumentSettlement"
            centered
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Detalhe da Liquidação"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            hide-footer
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    head-variant="dark"
                    :items="documentsettlements"
                    :fields="fieldsDocumentSettlement"
                ></b-table>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Stat from '../home/Stat'
import PageTitle from '../template/PageTitle'
import EntitySearchModal from '../util/EntitySearchModal'
var moment = require('moment')

export default {
    name: 'ReleasePaymentReceipt',
    components: { PageTitle, Stat, EntitySearchModal },
    data: function() {
        return {
            mode: 'insert',
            modeRelease: 'insert',
            stat: {},
            start_date: null,
            end_date: null,
            company_id: null,
            operation_id: null,
            entity_id: null,
            closed: 2,
            advance_balance: 0,
            total_plot_closed: 0,
            total_plot_open: 0,
            total_plot: 0,
            search: '',
            releasesplot: {},
            newreleasesplot: {},
            entity: {},
            releasesplotsadvance: {},
            release: {},
            releasesplots: [],
            operations: [],
            entitysshearch: [],
            companys: [],
            entitys: [],
            showEntity: false,
            entitysettlements: [],
            releasesplotsadvances: [],
            releasesplotsadvancesbyid: [],
            accountingentrys: [],
            documentsettlements: [],
            settlementforms: [],
            documentsettlement: {},
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            selectMode: 'multi',
            selected: [],
            perPage: 5,
            currentPage: 1,
            fieldsRelease: [
                {
                    key: 'due_date',
                    label: 'Vencto',
                    sortable: true,
                    variant: 'secondary',
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'scheduled_date',
                    label: 'Programação',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'portion_value', label: 'Vr. Parcela', sortable: false },
                { key: 'name_entity', label: 'Razão Social', sortable: false },
                { key: 'name_reduced', label: 'Doc.', sortable: false },
                { key: 'release_number', label: 'Nº.', sortable: false },
                {
                    key: 'final_value',
                    label: 'Vr. Final',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'closed',
                    label: 'Status',
                    sortable: false,
                    formatter: value => (value ? 'Pago' : 'Em Aberto')
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
                { key: 'accesses', label: 'Acesso', variant: 'secondary' }
            ],
            fieldsAdvances: [
                {
                    key: 'due_date',
                    label: 'Adiantamento em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'vr_adiantamento',
                    label: 'Vr. Adiantamento',
                    sortable: false
                },
                { key: 'vr_utilizado', label: 'Vr. Abatido', sortable: false },
                { key: 'vr_saldo', label: 'Vr. Saldo', sortable: false },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsAdvancesSplot: [
                {
                    key: 'advance_date',
                    label: 'Utilizado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'advance_value',
                    label: 'Vr. Utilizado',
                    sortable: false,
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsAccounting: [
                {
                    key: 'accounting_date',
                    label: 'Contabilizado',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Custo/Receita',
                    sortable: false
                },
                { key: 'account_plan', label: 'Conta', sortable: false },
                {
                    key: 'account_name_plan',
                    label: 'Descrição',
                    sortable: false
                },
                {
                    key: 'accounting_value',
                    label: 'Valor',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'accounting_nature_account',
                    label: 'Nat.',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_comments',
                    label: 'Historico',
                    sortable: false
                }
            ],
            fieldsDocumentSettlement: [
                {
                    key: 'settlement_date',
                    label: 'Liquidado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'user_name', label: 'Por' },
                { key: 'cnpj_cpf', label: 'Banco/Caixa', sortable: false },
                { key: 'name_entity', label: 'Nome', sortable: false },
                {
                    key: 'conciliation_date',
                    label: 'Conciliado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'compensation_date',
                    label: 'Compensado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                }
            ],
            questionboxyesnoalls: [
                { value: 0, text: 'Não' },
                { value: 1, text: 'Sim' },
                { value: 2, text: 'Ambos' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        searchglobal() {
            return this.$store.state.searchglobal
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.releasesplots.length
        },
        rowsEntitys() {
            return this.entitys.length
        }
    },
    methods: {
        showMsgBoxAccounting() {
            this.boxAccount = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Recontabilizar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxAccount = value
                    if (this.boxAccount === true) {
                        await this.reaccountingDocumentSettlement()
                    }
                })
        },
        showMsgBoxCanceled() {
            this.boxCanceled = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Cancelar a Liquidação ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCanceled = value
                    if (this.boxCanceled === true) {
                        await this.cancelSettlement()
                    }
                })
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        formatDate(date) {
            return moment.parseZone(date).format('YYYY-MM-DD')
        },
        formatDateTime(date) {
            return moment.parseZone(date).format('YYYY-MM-DD LT')
        },
        finalValue() {
            return (this.releasesplot.final_value = parseFloat(
                this.releasesplot.portion_value -
                    (this.releasesplot.discount_value
                        ? this.releasesplot.discount_value
                        : 0) -
                    (this.releasesplot.advance_portion_value
                        ? this.releasesplot.advance_portion_value
                        : 0) +
                    +(this.releasesplot.fine_value
                        ? this.releasesplot.fine_value
                        : 0) +
                    +(this.releasesplot.interest_rate_value
                        ? this.releasesplot.interest_rate_value
                        : 0)
            ).toFixed(2))
        },
        async loadReleasesAdvanced(releasesplot) {
            if (releasesplot.operation_id == 2) {
                const url_receipt = `${baseApiUrl}/releasesadvancereceipt/?company_id=${this.company_id}&entity_id=${releasesplot.entity_id}`
                await axios.get(url_receipt).then(res => {
                    this.releasesplotsadvances = res.data[0]
                })
            } else {
                const url_payment = `${baseApiUrl}/releasesadvancepayment/?company_id=${this.company_id}&entity_id=${releasesplot.entity_id}`
                await axios.get(url_payment).then(res => {
                    this.releasesplotsadvances = res.data[0]
                })
            }
        },
        async loadEntitySettlements() {
            const url = `${baseApiUrl}/entitysettement/${this.company_id}`
            await axios.get(url).then(res => {
                this.entitysettlements = res.data.map(entitysettlement => {
                    return {
                        value: entitysettlement.id,
                        text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`
                    }
                })
            })
        },
        loadReleasesPlot(releasesplot) {
            if (releasesplot.due_date)
                releasesplot.due_date = this.formatDate(releasesplot.due_date)
            if (releasesplot.scheduled_date)
                releasesplot.scheduled_date = this.formatDate(
                    releasesplot.scheduled_date
                )

            this.releasesplot = { ...releasesplot }
        },
        loadSettlement(releasesplot) {
            const datenow = new Date()
            this.documentsettlement = {}
            this.documentsettlement.settlement_date = this.formatDate(datenow)
            this.documentsettlement.release_plot_id = releasesplot.id
            this.documentsettlement.settlement_value = releasesplot.final_value
            this.documentsettlement.user_id = this.user.id
            this.documentsettlement.company_id = this.company_id
        },
        async loadSettlementReleaseSplot(releasesplot) {
            this.documentsettlement = {}
            this.releasesplot.final_value = releasesplot.final_value
            this.documentsettlement.release_plot_id = releasesplot.id

            const url = `${baseApiUrl}/documentsettlementsreleasesplots/${releasesplot.id}`
            await axios.get(url).then(res => {
                this.documentsettlement = res.data
            })
        },
        loadReleases() {
            const url = `${baseApiUrl}/releasesplotsearchdate/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}&closed=${this.closed}`
            axios.get(url).then(res => {
                this.releasesplots = res.data
            })

            this.loadReleaseTotalClosed()
            this.loadReleaseTotalOpen()
            this.loadReleaseTotal()
        },
        async loadReleaseTotalClosed() {
            this.total_plot_closed = 0

            if (this.closed == 1 || this.closed == 2) {
                const urlclosed = `${baseApiUrl}/documentsettlementssearchentitytotalclosed/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}`
                await axios.get(urlclosed).then(res => {
                    this.total_plot_closed = this.formatPrice(
                        res.data[0].portion_closed
                    )
                })
            }
        },
        async loadReleaseTotalOpen() {
            this.total_plot_open = 0

            if (this.closed == 0 || this.closed == 2) {
                const url = `${baseApiUrl}/documentsettlementssearchentitytotalopen/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}`
                await axios.get(url).then(res => {
                    this.total_plot_open = this.formatPrice(
                        res.data[0].portion_open
                    )
                })
            }
        },
        loadReleaseTotal() {
            this.total_plot = 0

            const url = `${baseApiUrl}/documentsettlementssearchentitytotal/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}&closed=${this.closed}`
            axios.get(url).then(res => {
                this.total_plot = this.formatPrice(res.data[0].portion_total)
            })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async setEntity() {
            const url = `${baseApiUrl}/entitys/${this.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        async savePlot() {
            this.releasesplot.user_update_id = this.user.id
            this.releasesplot.update_date = this.formatDate(moment.utc())

            const method = this.releasesplot.id ? 'put' : 'post'
            const id = `/${this.releasesplot.id}`
            await axios[method](
                `${baseApiUrl}/releasesplots${id}`,
                this.releasesplot
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        async saveNewPlot() {
            if (
                this.newreleasesplot.portion_value &&
                this.newreleasesplot.due_date
            ) {
                this.releasesplot.portion_value =
                    parseFloat(this.releasesplot.portion_value).toFixed(2) -
                    parseFloat(this.newreleasesplot.portion_value).toFixed(2)
                this.releasesplot.fine_value = 0
                this.releasesplot.interest_rate_value = 0
                this.releasesplot.discount_value = 0
                this.releasesplot.final_value = this.releasesplot.portion_value

                this.releasesplot.user_update_id = this.user.id
                this.releasesplot.update_date = this.formatDateTime(Date())

                this.newreleasesplot.release_id = this.releasesplot.release_id

                const method = 'put'
                const id = `/${this.releasesplot.id}`
                await axios[method](
                    `${baseApiUrl}/releasesplots${id}`,
                    this.releasesplot
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)

                const method_new = 'post'
                await axios[method_new](
                    `${baseApiUrl}/releasesplots`,
                    this.newreleasesplot
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            } else {
                this.$toasted.global
                    .defaultWarning({
                        msg: 'Informe a Data de Vencimento/Valor da Parcela'
                    })
                    .catch(showError)
            }

            const method = this.releasesplot.id ? 'put' : 'post'
            const id = `/${this.releasesplot.id}`
            await axios[method](
                `${baseApiUrl}/releasesplots${id}`,
                this.releasesplot
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        async saveSettlement() {
            const method = 'post'
            await axios[method](
                `${baseApiUrl}/documentsettlements`,
                this.documentsettlement
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    if (this.compan.require_account_entry === 1) {
                        await this.getLastdocumentSettlement()
                        await this.reaccountingRelease()
                    }
                    await this.loadReleases()
                })
                .catch(showError)
        },
        async unblocked(releasesplot) {
            const id = releasesplot.id
            await axios
                .put(`${baseApiUrl}/unblockedreleasespot/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadReleases()
                })
                .catch(showError)
        },
        async blocked(releasesplot) {
            const id = releasesplot.id
            await axios
                .put(`${baseApiUrl}/blockedreleasespot/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        setSearchEntity(entity) {
            this.entity_id = entity.id
            this.entity = { ...entity }
        },
        async cancelSettlement() {
            this.documentsettlement.canceled = true
            this.documentsettlement.user_canceled_id = this.user.id
            this.documentsettlement.canceled_date = this.formatDateTime(Date())

            const method = 'put'
            const id = `/${this.documentsettlement.id}`
            await axios[method](
                `${baseApiUrl}/documentsettlements${id}`,
                this.documentsettlement
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        async printerRelease() {
            if (!this.start_date || !this.end_date) {
                this.$toasted.global.defaultError({ msg: 'Data não informada' })
            } else if (!this.company_id) {
                this.$toasted.global.defaultError({
                    msg: 'Empresa não informada'
                })
            } else if (!this.operation_id) {
                this.$toasted.global.defaultError({
                    msg: 'Operação não informada'
                })
            } else {
                const url = `${baseApiUrl}/releasesplotdatestatusprinter/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}&closed=${this.closed}`
                await axios.get(url)
                window.open(url)
            }
        },
        async releaseSplotExpired() {
            let date = new Date()
            date = moment.utc(date).format('YYYY-MM-DD')

            await axios
                .get(
                    `${baseApiUrl}/documentsettlementsreleasesplotexpired/?start_date=${date}`
                )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },
        rowSelected(items) {
            this.selected = items
        },
        async saveReleaseSplotAdvanceUnit() {
            if (
                this.advance_balance < this.releasesplotsadvance.advance_value
            ) {
                this.$toasted.global.defaultError({
                    msg:
                        'Valor de Abatimento maior que o Saldo de Adiantamento...'
                })
            } else {
                const method = 'post'
                await axios[method](
                    `${baseApiUrl}/releasesplotsadvances`,
                    this.releasesplotsadvance
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            }
        },
        loadReleaseSplotAdvance(releasesplot) {
            const datenow = new Date()
            this.releasesplotsadvance = {}
            this.releasesplotsadvance.advance_date = this.formatDate(datenow)
            this.releasesplotsadvance.release_plot_id = releasesplot.id
            this.releasesplotsadvance.user_id = this.user.id
        },
        setAdvanced(releasesadvanced) {
            this.advance_balance = parseFloat(releasesadvanced.vr_saldo)
            this.releasesplotsadvance.release_plot_origin_id =
                releasesadvanced.id
            this.releasesplotsadvance.entity_settlement_id =
                releasesadvanced.entity_id
        },
        async reaccountingRelease() {
            if (this.compan.require_account_entry === 1) {
                await axios['post'](
                    `${baseApiUrl}/accountingreleasesplot`,
                    this.documentsettlement
                )
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.loadReleases()
                    })
                    .catch(showError)
            }
        },
        async reaccountingDocumentSettlement() {
            if (this.compan.require_account_entry === 1) {
                this.documentsettlement = this.documentsettlements[0]
                if (this.documentsettlement.id > 0) {
                    await axios['post'](
                        `${baseApiUrl}/accountingreleasesplot`,
                        this.documentsettlement
                    )
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loadReleases()
                        })
                        .catch(showError)
                }
            } else {
                this.$toasted.global.defaultError({
                    msg:
                        'Empresa não está configurado para utilizar a contabilização...'
                })
            }
        },
        async accountingRelease(releasesplot) {
            const id = releasesplot.id
            await axios
                .get(`${baseApiUrl}/accountingentrysreleasesplots/${id}`)
                .then(res => {
                    this.accountingentrys = res.data
                })
        },
        async documentSettlementRelease(releasesplot) {
            const id = releasesplot.id
            await axios
                .get(
                    `${baseApiUrl}/releasesplotbydetaildocumentsettlement/${id}`
                )
                .then(res => {
                    this.documentsettlements = res.data
                })
        },
        async getLastdocumentSettlement() {
            const url = `${baseApiUrl}/documentsettlementslastid/${this.documentsettlement.release_plot_id}`
            await axios(url).then(
                res => (this.documentsettlement = { ...res.data })
            )
        },
        loadSettlementForms() {
            const url = `${baseApiUrl}/settlementforms`
            axios.get(url).then(res => {
                this.settlementforms = res.data.map(settlementform => {
                    return {
                        value: settlementform.id,
                        text: settlementform.name_settlement_form
                    }
                })
            })
        },
        actionEditRelease(releasesplot) {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(this.searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id,
                operation_id_release: this.operation_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                this.searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            this.$router.push({
                name: 'Recordrelease',
                query: { releasebase: releasesplot }
            })
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        },
        async printerPaymentReceipt() {
            if (!this.start_date || !this.end_date) {
                this.$toasted.global.defaultError({ msg: 'Data não informada' })
            } else if (!this.company_id) {
                this.$toasted.global.defaultError({
                    msg: 'Empresa não informada'
                })
            } else if (!this.operation_id) {
                this.$toasted.global.defaultError({
                    msg: 'Operação não informada'
                })
            } else {
                const url = `${baseApiUrl}/releasesplotdatestatusprinter/?start_date=${this.start_date}&end_date=${this.end_date}&company_id=${this.company_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}&closed=${this.closed}`
                await axios.get(url)
                window.open(url)
            }
        }
    },
    async mounted() {
        this.loadCompanys()
        this.loadOperation()
        this.loadSettlementForms()

        if (this.searchglobal) {
            this.start_date = moment(
                this.searchglobal.start_date_release
            ).format('YYYY-MM-DD')
            this.end_date = moment(this.searchglobal.end_date_release).format(
                'YYYY-MM-DD'
            )
            this.company_id = this.searchglobal.company_id_release
            this.operation_id = this.searchglobal.operation_id_release
            await this.loadReleases()
        } else {
            let date = new Date()
            let fist_day_month = new Date(
                date.getFullYear(),
                date.getMonth(),
                1
            )
            let Last_day_month = new Date(
                date.getFullYear(),
                date.getMonth() + 1,
                0
            )

            this.start_date = moment(fist_day_month).format('YYYY-MM-DD')
            this.end_date = moment(Last_day_month).format('YYYY-MM-DD')
            if (this.compan) {
                this.company_id = this.compan.id
            }

            await this.loadReleases()
        }
        this.showTable = true

        // this.releaseSplotExpired() Mudar o local de rodar
    }
}
</script>

<style>
.stats {
    flex: 1;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 0px 45px 0px 45px;
    border-radius: 60px;
}

.stats {
    font-size: 0.7rem;
}

.release-payment-receipt {
    font-size: 0.7rem;
}

.release-payment-receipt input,
label,
form {
    font-size: 0.7rem;
}
.release-payment-receipt button {
    font-size: 0.7rem;
}

.release-payment-receipt select {
    font-size: 0.7rem;
}

.release-payment-receipt table {
    font-size: 0.7rem;
}

#modalNwePlots {
    font-size: 0.7rem;
}

#modalNwePlots input,
label,
form {
    font-size: 0.7rem;
}

#modalNwePlots button {
    font-size: 0.7rem;
}

#modalNwePlots select {
    font-size: 0.7rem;
}

#modalPlots {
    font-size: 0.7rem;
}

#modalPlots input,
label,
form {
    font-size: 0.7rem;
}

#modalPlots button {
    font-size: 0.7rem;
}

#modalPlots select {
    font-size: 0.7rem;
}

#modalSettlement {
    font-size: 0.7rem;
}

#modalSettlement input,
label,
form {
    font-size: 0.7rem;
}

#modalSettlement button {
    font-size: 0.7rem;
}

#modalSettlement select {
    font-size: 0.7rem;
}

#modalEntity {
    font-size: 0.7rem;
}

#modalEntity input,
label,
form {
    font-size: 0.7rem;
}

#modalEntity button {
    font-size: 0.7rem;
}

#modalEntity select {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
